/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import Modal from "../common_modal/Modal";
import FLOAT_MENU from "../common_trivial/FLOAT_MENU";
import ProgressBar from "../common_spinner/ProgressBar";
import SINI_AI from "./SINI_AI";
import SINI_DEMOGRAPHY from "./SINI_DEMOGRAPHY";
import SINI_ISOCHRONE from "./SINI_ISOCHRONE";
import SINI_PEOPLE_SPENDING from "./SINI_PEOPLE_SPENDING";
import SINI_LAND from "./SINI_LAND";
import SINI_DISASTER_RISK from "./SINI_DISASTER_RISK";
import SINI_RDTR from "./SINI_RDTR";
import SINI_POI from "./SINI_POI";
import SINI_DEMOGRAPHY_FULL from "../sini_v2_full/SINI_DEMOGRAPHY_FULL";
import SINI_PEOPLE_SPENDING_FULL from "../sini_v2_full/SINI_PEOPLE_SPENDING_FULL";
import SINI_LAND_FULL from "../sini_v2_full/SINI_LAND_FULL";
import SINI_DISASTER_RISK_FULL from "../sini_v2_full/SINI_DISASTER_RISK_FULL";
import SINI_RDTR_FULL from "../sini_v2_full/SINI_RDTR_FULL";
import SINI_POI_FULL from "../sini_v2_full/SINI_POI_FULL";
import SINI_CHAT_AI_FULL from "../sini_v2_full/SINI_CHAT_AI_FULL";
import SINI_AI_PAGE from "../sini_v2_full/SINI_AI_PAGE";
import SINI_HISTORY_FLY from "./SINI_HISTORY_FLY";

/*REDUX*/
import { set_value_toolbox } from "../../App/actions/toolboxActions";
import {
  set_value_sini,
  fly_init_update,
  get_ai_parent_list,
  get_ai_child_list,
  get_ai_parent_object,
} from "../../App/actions/sini_v2";
import { set_value_user } from "../../App/actions/authActions";
import { set_value_layer } from "../../App/actions/layerActions";
import {
  get_list_tipe_1,
  get_list_tipe_2,
  get_list_tipe_3,
  get_list_tipe_2_properti,
} from "../../App/actions/insight_v2";
import {
  is_has_license_basic_and_license_sharing,
  is_pass_license_or_quota,
  is_user_get_access_by_license_key,
} from "../../App/actions/filter_license";

/*PICTURE*/
import ICON_CHOOSE_MAP from "../../Assets/jsx/ICON_CHOOSE_MAP";
import ICON_CHAT_AI from "../../Assets/jsx/ICON_CHAT_AI";
import ICON_FLY_SINI from "../../Assets/jsx/ICON_FLY_SINI";
import SINI_ILUSTRATION from "../../Assets/jsx/SINI_ILUSTRATION";

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";
import domain_list from "../../Data/domain_list";
import BLOCKED from "../sini_data/BLOCKED";

/*CONST*/

class PARENT_SINI extends Component {
  state = {
    anchor: null,
    modalLogin: false,
    modal_history: false,
    modal_rdtr: false,
    is_insight: false,
  };

  componentDidMount() {
    const { from } = this.props;
    const { isAuthenticated, user } = this.props.auth;
    const quota_access = user?.quota_access || 0;
    if (
      isAuthenticated &&
      // this.props.is_has_license_basic_and_license_sharing() ||
      quota_access > 0
    ) {
      this.props.get_ai_parent_list(from);
    }

    //tipe
    const { list_tipe_1, list_tipe_2, list_tipe_3 } =
      this.props.insight_reducer;
    if (list_tipe_1?.length === 0) {
      this.props.get_list_tipe_1();
    }
    if (list_tipe_2?.length === 0) {
      this.props.get_list_tipe_2();
    }
    if (list_tipe_3?.length === 0) {
      this.props.get_list_tipe_3();
    }
    this.props.get_list_tipe_2_properti();
  }

  componentWillUnmount() {
    this.props.set_value_sini({
      key: "sini_menu_active",
      value: "",
    });
    this.props.set_value_sini({
      key: "sini_map_show",
      value: ["poi", "isochrone"],
    });
  }

  activate_insight = () => {
    this.setState({ is_insight: true });
  };

  activate_map = (e) => {
    this.setState({
      modal_rdtr: false,
      is_insight: false,
    });

    if (
      this.props.is_user_get_access_by_license_key("license_sini_data")?.is_pass
      // this.props.is_pass_license_or_quota()
    ) {
      const domain = this?.props?.auth?.domain || "";
      const name = e.target.name;
      if (name === "sini_general" || name === "sini_rdtr") {
        //LOLOS, AKTIFKAN DRAW
        this.props.set_value_sini({
          key: "sini_data_mode",
          value: name,
        });
        this.on_draw();
      } else if (domain_list?.[domain]?.is_domain_kai) {
        //KHUSUS KAI, MUNCUL OPSI APAKAH MAU SINI ATAU RDTR SAJA
        this.toggle_rdtr(e);
      } else {
        //HANDLE KEMUNGKINAN LAIN
        this.on_draw();
      }
    }
  };

  on_draw = () => {
    //state management draw
    this.props.set_value_layer({
      key: "draw_state_platform",
      value: "sini",
    });

    //bagian map
    const { map_object } = this.props.layer;
    const draw_object = this.props.layer.draw_object;

    if (map_object && draw_object) {
      map_object.getCanvas().style.cursor = "crosshair";
      draw_object.changeMode("draw_point");
    }
  };

  toggle_sini_visible = () => {
    this.props.set_value_sini({
      key: "is_sini_visible",
      value: !this.props.sini.is_sini_visible,
    });
  };

  toggle_error_limitation = () => {
    this.props.set_value_sini({
      key: "modal_error_limitation",
      value: !this.props.sini.modal_error_limitation,
    });
  };

  toggle_error_bill_ai = () => {
    this.props.set_value_sini({
      key: "modal_error_bill_ai",
      value: !this.props.sini.modal_error_bill_ai,
    });
  };

  toggle_rdtr = (event) => {
    if (event) {
      this.setState({
        anchor: event.currentTarget,
        modal_rdtr: true,
        modal_history: false,
      });
    } else {
      this.setState({
        anchor: "",
        modal_rdtr: false,
        modal_history: false,
      });
    }
  };

  open_history = (event) => {
    const { isAuthenticated } = this.props.auth;
    if (!isAuthenticated) {
      this.toggle_login();
      return;
    }
    this.setState({
      anchor: event.currentTarget,
      modal_history: true,
      modal_rdtr: false,
    });
  };

  close_history = () => {
    this.setState({
      anchor: "",
      modal_history: false,
      modal_rdtr: false,
    });
  };

  toggle_payment_universal = () => {
    const { modal_payment_universal } = this.props.auth;
    this.props.set_value_user(
      "modal_payment_universal",
      !modal_payment_universal
    );
  };

  toggle_quota_access = () => {
    const { modal_quota_access } = this.props.auth;
    this.props.set_value_user("modal_quota_access", !modal_quota_access);
  };

  toggle_login = () => {
    const { modal_login } = this.props.auth;
    this.props.set_value_user("modal_login", !modal_login);
  };

  toggle_ai_page = () => {
    this.setState({ is_insight: false });
    const { isAuthenticated } = this.props.auth;
    if (!isAuthenticated) {
      this.toggle_login();
    } else {
      this.props.set_value_sini({
        key: "modal_ai_page",
        value: !this.props.sini.modal_ai_page,
      });
    }
  };

  on_cancel_activate_map = () => {
    this.props.set_value_sini({
      key: "mode_draw",
      value: "simple_select",
    });
    this.props.set_value_layer({
      key: "draw_state_platform",
      value: "",
    });
    const { map_object } = this.props.layer;
    const draw_object = this.props.layer.draw_object;

    if (map_object) {
      map_object.getCanvas().style.cursor = ""; //reset cursor
      if (draw_object) {
        draw_object?.changeMode("simple_select"); //deactivate draw mode
        draw_object?.deleteAll();
      }
    }
  };

  on_toggle_zoom = () => {
    this.props.set_value_sini({
      key: "is_stop_zoom",
      value: !this.props.sini.is_stop_zoom,
    });
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state
    const {
      anchor,
      modal_history,
      modal_rdtr,
      // is_insight
    } = this.state;

    //global props
    const { draw_state_platform } = this.props.layer;
    const { from } = this.props;
    const {
      request_id_active,
      sini_v2_list,
      ai_parent_detail_list,
      sini_menu_active,
      is_stop_zoom,
      error_limitation,
      modal_ai_page,
      modal_error_limitation,
      modal_error_bill_ai,
      is_sini_visible,
      total_step,
      current_step,
      current_topic_loading,
    } = this.props.sini;
    const { loading_item_array } = this.props.loading_reducer;
    const domain = this?.props?.auth?.domain || "";
    const is_has_access_sini =
      this.props.is_user_get_access_by_license_key("license_sini_data");

    //content
    const is_domain_kai = domain_list?.[domain]?.is_domain_kai;
    const merge_array = [...sini_v2_list, ...ai_parent_detail_list];
    const sini_object = merge_array.find(
      (item) => item.request_id === request_id_active
    );
    let content;

    if (
      draw_state_platform === "sini" &&
      !loading_item_array.includes("sini_load_parent")
    ) {
      content = (
        <main>
          <section style={{ textAlign: "center", marginTop: "30px" }}>
            <SINI_ILUSTRATION />
            <br />
            <br />
            <div className="text_bold">
              {dict?.["Select the click location on the map"]?.[language]}
            </div>
            <br />
            <button
              className="button background_grey"
              onClick={this.on_cancel_activate_map}
            >
              {dict?.["Cancel"]?.[language]}
            </button>
          </section>
        </main>
      );
    } else if (!!sini_object?.lat) {
      if (sini_menu_active === "") {
        if (sini_object?.title_1 === "RDTR") {
          content = (
            <>
              <SINI_RDTR_FULL no_back_button={true} />
              <SINI_AI />
            </>
          );
        } else {
          content = (
            <section>
              {from !== "ai_hbu" && <SINI_AI />}
              <SINI_DEMOGRAPHY />
              <SINI_ISOCHRONE />
              <SINI_PEOPLE_SPENDING />
              <SINI_LAND />
              <SINI_DISASTER_RISK />
              <SINI_POI />
              {is_domain_kai && <SINI_RDTR />}
              {sini_menu_active === "" && (
                <button
                  className="button background_grey"
                  onClick={this.on_toggle_zoom}
                  style={{ marginBottom: "50px" }}
                >
                  {is_stop_zoom ? "Zoom tidak aktif" : "Zoom aktif"}
                </button>
              )}
            </section>
          );
        }
      } else {
        if (sini_menu_active === "demography_properties") {
          content = <SINI_DEMOGRAPHY_FULL />;
        } else if (sini_menu_active === "people_spending") {
          content = <SINI_PEOPLE_SPENDING_FULL />;
        } else if (sini_menu_active === "landvalue") {
          content = <SINI_LAND_FULL />;
        } else if (sini_menu_active === "flood") {
          content = <SINI_DISASTER_RISK_FULL />;
        } else if (sini_menu_active === "rdtr") {
          content = <SINI_RDTR_FULL />;
        } else if (sini_menu_active === "poi") {
          content = <SINI_POI_FULL />;
        } else if (sini_menu_active === "post_ai_chat") {
          content = <SINI_CHAT_AI_FULL />;
        } else {
          content = <SINI_DEMOGRAPHY_FULL />;
        }
      }
    } else {
      if (from !== "ai_hbu") {
        content = is_has_access_sini?.is_pass ? (
          <section
            style={{
              textAlign: "center",
              marginTop: "30px",
            }}
          >
            <SINI_ILUSTRATION />
            <br />
            <br />
            <div className="text_bold" style={{ marginBottom: "10px" }}>
              {dict?.["Click the plus button to get started SINI"]?.[language]}
            </div>
            <button
              id="blue"
              className="button_circle"
              style={{ fontSize: "50px", marginBottom: "15px" }}
              onClick={this.activate_map}
              data-mapid="clickAddSini"
            >
              <div className="button_circle_inside">+</div>
            </button>
          </section>
        ) : (
          <div
            style={{
              minHeight: "300px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <BLOCKED {...is_has_access_sini} />
          </div>
        );
      }
    }

    const modal_history_content = modal_history && (
      <FLOAT_MENU
        id="basic-menu"
        anchorEl={anchor}
        open={modal_history}
        onClose={this.close_history}
      >
        <div
          style={{
            width: "250px",
            maxHeight: "calc( 100vh - 290px )",
            overflowY: "auto",
          }}
        >
          <SINI_HISTORY_FLY close_history={this.close_history} />
        </div>
      </FLOAT_MENU>
    );

    const modal_rdtr_content = modal_rdtr && (
      <FLOAT_MENU
        id="basic-menu"
        anchorEl={anchor}
        open={modal_rdtr}
        onClose={this.toggle_rdtr}
      >
        <div>
          <button
            className="button_big button_white margin_bottom"
            name="sini_rdtr"
            onClick={this.activate_map}
            data-mapid="clickKalkulatorRDTR"
          >
            KALKULATOR RDTR
          </button>
          <br />
          <button
            className="button_big button_white margin_bottom"
            name="sini_general"
            onClick={this.activate_map}
            data-mapid="clickKalkulatorSINI"
          >
            SINI
          </button>
        </div>
      </FLOAT_MENU>
    );

    const modal_ai_page_content = modal_ai_page && (
      <Modal
        modalSize="large"
        isOpen={modal_ai_page}
        onClose={this.toggle_ai_page}
      >
        <div className="box-body" id="box-body">
          <section style={{ minHeight: "calc( 100vh - 170px )" }}>
            <SINI_AI_PAGE />
          </section>
        </div>
      </Modal>
    );

    const modal_error_limitation_content = modal_error_limitation && (
      <Modal
        modalSize="small"
        is_hide="hide"
        backgroundColor="rgba(255, 255, 255, 1);"
        use_blur={false}
        blur_value="5px"
        borderRadius="30px"
        isOpen={modal_error_limitation}
        onClose={this.toggle_error_limitation}
      >
        <div className="box-body" id="box-body">
          <h1>{error_limitation?.[language]}</h1>
          <br />
          <button
            onClick={this.toggle_quota_access}
            className="button background_black"
          >
            {dict?.["Buy access now"]?.[language]}
          </button>
        </div>
      </Modal>
    );

    const modal_error_bill_ai_content = modal_error_bill_ai && (
      <Modal
        modalSize="small"
        is_hide="hide"
        backgroundColor="rgba(255, 255, 255, 1);"
        use_blur={false}
        blur_value="5px"
        borderRadius="30px"
        isOpen={modal_error_bill_ai}
        onClose={this.toggle_error_bill_ai}
      >
        <div className="box-body" id="box-body">
          <h1>{error_limitation?.[language]}</h1>
        </div>
      </Modal>
    );

    return (
      <main style={{ overflowX: "hidden" }}>
        {modal_rdtr_content}
        {modal_ai_page_content}
        {modal_history_content}
        {modal_error_limitation_content}
        {modal_error_bill_ai_content}

        {sini_menu_active === "" && (
          <>
            {from !== "ai_hbu" && (
              <section
                className="parent_menu"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div
                  className={`container_light ${
                    is_has_access_sini?.is_pass
                      ? "background_grey_light button_white pointer"
                      : "bg_darkGrey text_white"
                  } margin_right margin_bottom inline_block noselect`}
                  style={{
                    flex: "1",
                    minHeight: "60px",
                    marginRight: "3px",
                    // backgroundColor: is_has_access_sini?.is_pass ? "red": "blue"
                  }}
                  onClick={this.activate_map}
                >
                  <ICON_CHOOSE_MAP />
                  <br />
                  <p className="text_small">
                    {is_domain_kai
                      ? "Kalkulator RDTR"
                      : dict?.["Click on map"]?.[language]}
                  </p>
                </div>

                <div
                  className="container_light pointer background_grey_light margin_right margin_bottom inline_block button_white noselect"
                  style={{
                    flex: "1",
                    minHeight: "60px",
                    marginRight: "3px",
                  }}
                  onClick={this.toggle_ai_page}
                >
                  <ICON_CHAT_AI />
                  <br />
                  <p className="text_small">
                    {dict?.["AI history"]?.[language]}
                  </p>
                </div>

                <div
                  id="history_trigger"
                  className="container_light pointer background_grey_light margin_right margin_bottom inline_block button_white noselect"
                  style={{
                    flex: "1",
                    minHeight: "60px",
                    marginRight: "3px",
                  }}
                  onClick={this.open_history}
                >
                  <ICON_FLY_SINI />
                  <br />
                  <p className="text_small">
                    {dict?.["History shortcut"]?.[language]}
                  </p>
                </div>
              </section>
            )}

            <table>
              <tbody>
                <tr>
                  <td onClick={this.toggle_sini_visible}>
                    <button
                      className={
                        is_sini_visible ? "checklist_active" : "checklist_not"
                      }
                    />
                  </td>
                  <td
                    onClick={this.toggle_sini_visible}
                    className="cursor_pointer text_medium"
                  >
                    {dict?.["Show SINI"]?.[language]}
                  </td>
                </tr>
              </tbody>
            </table>
          </>
        )}
        {total_step !== current_step && (
          <ProgressBar
            current_number={current_step}
            total_number={total_step}
            name={current_topic_loading}
          />
        )}
        {loading_item_array.includes("get_ai_parent_object") && (
          <section className="container_light background_grey_light">
            {dict?.["Loading"]?.[language]}...
          </section>
        )}
        {content}
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  map: state.map,
  license_reducer: state.license_reducer,
  sini: state.sini,
  loading_reducer: state.loading_reducer,
  layer: state.layer,
  insight_reducer: state.insight_reducer,
});

export default connect(mapStateToProps, {
  set_value_sini,
  set_value_toolbox,
  fly_init_update,
  set_value_user,
  get_ai_parent_list,
  get_ai_child_list,
  get_ai_parent_object,
  set_value_layer,
  get_list_tipe_1,
  get_list_tipe_2,
  get_list_tipe_3,
  get_list_tipe_2_properti,
  is_has_license_basic_and_license_sharing,
  is_pass_license_or_quota,
  is_user_get_access_by_license_key,
})(PARENT_SINI);
